import React from 'react'
import { Card, CardContent, Typography, Autocomplete, TextField, Checkbox, Chip, Box, CircularProgress } from '@mui/material';
import { People } from '@mui/icons-material';
import { Controller, useFormContext } from 'react-hook-form';
import CSVMatchUpload from './CSVMatchUpload';
const CustomerSelection = ({ filteredData, isLoading,getFullName, notificationData, setNotificationData }) => {
        const { control, setValue } = useFormContext();
        const handleCustomerSelectionChange = (event, newValues) => {
            const hasSelectAll = newValues.some(val => val.id === '__all__');

            if (hasSelectAll) {
                const selectedCustomers = notificationData.customerFilters?.selectedCustomers || [];
                const isAllSelected = selectedCustomers.length === filteredData.length;
                if (isAllSelected) {
                    return [];
                } else {
                    return filteredData.map(item => ({ id: item.id }));
                }
                
                // if (isAllSelected) {
                //     setNotificationData(prev => ({
                //         ...prev,
                //         customerFilters: {
                //             ...prev.customerFilters,
                //             selectedCustomers: []
                //         }
                //     }));
                // } else {
                //     setNotificationData(prev => ({
                //         ...prev,
                //         customerFilters: {
                //             ...prev.customerFilters,
                //             selectedCustomers: filteredData.map(item => ({ id: item.id }))
                //         }
                //     }));
                // }
            } else {
                // setNotificationData(prev => ({
                //     ...prev,
                //     customerFilters: {
                //         ...prev.customerFilters,
                //         selectedCustomers: newValues.map(item => ({ id: item.id }))
                //     }
                // }));
                return newValues.map(item => ({ id: item.id }));
            }
        };

        const selectedCustomers = notificationData.customerFilters?.selectedCustomers || [];
        const selectedIds = selectedCustomers.map(c => c.id);
        const isAllSelected = filteredData.length > 0 && selectedIds.length === filteredData.length;
        const isIndeterminate = selectedIds.length > 0 && selectedIds.length < filteredData.length;

        const selectAllOption = {
            id: '__all__',
            profile: { firstName: 'Select All Customers' },
        };

        const optionsWithSelectAll = [selectAllOption, ...filteredData];

        return (
            <Card variant="outlined">
                <CardContent>
                    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <People fontSize="small" />
                        Select Customers to Notify
                    </Typography>
                    <Controller
                        name='customerFilters.selectedCustomers'
                        rules={{
                            required : 'Please Select Customers',
                            validate: (value) => (value && Object.keys(value).length > 0) || 'Select customer'
                        }}
                        control={control}
                        render ={({field: { onChange, value },fieldState:{error}})=>(
                            <Autocomplete
                                multiple
                                disableCloseOnSelect
                                options={optionsWithSelectAll}
                                value={value}
                                loading={isLoading}
                                // onChange={handleCustomerSelectionChange}
                                onChange={(event, newValue) => {
                                    let newVal = handleCustomerSelectionChange(event, newValue);
                                    onChange(newVal);
                                }}
                                getOptionLabel={(option) => {
                                    if (option.id === '__all__') return 'Select All Customers';
                                    const profile = option.profile || {};
                                    return `${getFullName(profile)} (${option.mobileNumber || ''})`;
                                }}
                                isOptionEqualToValue={(option, val) => option.id === val.id}
                                renderOption={(props, option, { selected }) => {
                                    if (option.id === '__all__') {
                                        return (
                                            <li {...props}>
                                                <Checkbox
                                                    checked={isAllSelected}
                                                    indeterminate={isIndeterminate}
                                                    size="small"
                                                    sx={{ mr: 1 }}
                                                />
                                                <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                                    Select All Customers
                                                </Typography>
                                            </li>
                                        );
                                    }

                                    const profile = option.profile || {};
                                    const fullName = getFullName(profile);
                                    return (
                                        <li {...props}>
                                            <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
                                            <Box>
                                                <Typography sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                                                    {fullName}
                                                    {option.isTester && (
                                                        <Box component="span" sx={{
                                                            ml: 1,
                                                            background: '#ffecb3',
                                                            px: 0.5,
                                                            borderRadius: '4px',
                                                            fontSize: '0.65rem',
                                                        }}>
                                                            Tester
                                                        </Box>
                                                    )}
                                                    <Box component="span" sx={{ ml: 1, fontSize: '0.7rem', color: '#666' }}>
                                                        ({option.mobileNumber})
                                                    </Box>
                                                </Typography>
                                                {option.coordinates && (
                                                    <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary' }}>
                                                        Location: {option.coordinates.lat.toFixed(4)}, {option.coordinates.lng.toFixed(4)}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </li>
                                    );
                                }}
                                renderTags={(tagValue, getTagProps) => {
                                    const selectedIds = tagValue.map(c => c.id);
                                    const allSelected = filteredData.length > 0 && selectedIds.length === filteredData.length;

                                    if (allSelected) {
                                        return (
                                            <Chip
                                                label={`All Customers (${filteredData.length})`}
                                                size="small"
                                                sx={{ fontSize: '0.7rem', height: '24px', mr: 0.5 }}
                                            />
                                        );
                                    }

                                    return tagValue.map((option, index) => {
                                        const profile = filteredData.find(item => item.id === option.id)?.profile || {};
                                        const fullName = getFullName(profile);
                                        return (
                                            <Chip
                                                label={fullName}
                                                size="small"
                                                {...getTagProps({ index })}
                                                sx={{
                                                    fontSize: '0.7rem',
                                                    height: '24px',
                                                    mr: 0.5
                                                }}
                                            />
                                        );
                                    });
                                }}
                                noOptionsText={<span style={{ fontSize: '0.75rem' }}>No customers found</span>}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        placeholder="Select customers to notify"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { fontSize: '0.75rem', color: '#000' },
                                            endAdornment: (
                                                <>
                                                    {isLoading && <CircularProgress size={16} />}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        )}
                    />
                    
                    {/* CSV Upload for Bulk Selection */}
                    <CSVMatchUpload
                        registeredList={filteredData}
                        audienceType="customer"
                        isLoading={isLoading}
                        onMatch={(matchedUsers) => {
                            // Map matched users to the format expected by the autocomplete
                            const newSelection = matchedUsers.map(user => ({ id: user.id }));
                            
                            // Update the form control value
                            setValue('customerFilters.selectedCustomers', newSelection, { shouldValidate: true });
                            
                            // Also update notificationData for consistency
                            setNotificationData(prev => ({
                                ...prev,
                                customerIds: newSelection
                            }));
                        }}
                    />
                    
                </CardContent>
            </Card>
        );
    };

export default CustomerSelection
